var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"pt-3"},[_c('b-button',{directives:[{name:"print",rawName:"v-print",value:('#print-referralfee'),expression:"'#print-referralfee'"}]},[_vm._v("列印")]),_c('print-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }